import { ReactElement } from 'react';
import { DashboardContainer } from '../../../../modules/common/dashboard/DashboardContainer';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { AttachmentImagePreviewContainer } from '../../../modules/attachments/containers/AttachmentImagePreview.container';
import { AttachmentsPreviewHeaderContainer } from '../../../modules/attachments/containers/AttachmentsPreviewHeader.container';

export const AttachmentImagePreviewView = (): ReactElement => (
  <DashboardContainer>
    <ColumnLayout size='none'>
      <AttachmentsPreviewHeaderContainer />
      <AttachmentImagePreviewContainer />
    </ColumnLayout>
  </DashboardContainer>
);
